module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/everyday-humans-d25f5cf0dc497b8efc48b419b74fe2a8.svg";